import { render } from "./RecordButton.vue?vue&type=template&id=b7142290&ts=true"
import script from "./RecordButton.vue?vue&type=script&lang=ts"
export * from "./RecordButton.vue?vue&type=script&lang=ts"

import "./RecordButton.vue?vue&type=style&index=0&id=b7142290&lang=scss"

import exportComponent from "/home/node/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__